import apiProvider from './api/utilities/provider'

const apiCapabilities = {
  getCapabilities: (config) => apiProvider.getAll('capabilities', config),
}

export default apiCapabilities
